import { render, staticRenderFns } from "./send-coupons.vue?vue&type=template&id=c70502fc&"
import script from "./send-coupons.vue?vue&type=script&lang=js&"
export * from "./send-coupons.vue?vue&type=script&lang=js&"
import style0 from "./send-coupons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports